var exports = {
  "k": "InviteDateToggle.module__container___SjZfdj",
  "P": "InviteDateToggle.module__label___SjZfdj",
};

module.exports = exports;
